const $ = require("jquery");
require("datatables.net");
require("datatables.net-fixedheader");
require("datatables.net-select");
require("datatables.net-bs");
var languageDE = require("datatables.net-plugins/i18n/de-DE.js");

window.addEventListener("load", function () {
  $("table.dt").DataTable({
    language: languageDE,
    fixedHeader: true,
    displayLength: -1,
    dom:
      "<'row'<'col-md-3'l><'#datatables-custom.col-md-6'><'col-md-3 text-right'f>>" +
      "<'row'<'col-md-12'tr>>" +
      "<'row'<'col-md-5'i><'col-md-7 text-right'p>>",
    lengthMenu: [
      [10, 25, 50, -1],
      [10, 25, 50, "Alle"],
    ],
    initComplete() {
      const selector = '[data-provides="datatables-custom"]';
      const $wrapper = $(this).parentsUntil(".dt-container").last().parent();

      const wrapperId = $wrapper.prop("id");
      const $victim = $wrapper.prevUntil(selector).prev();
      if ($victim.length === 1) {
        $victim
          .detach()
          .prependTo(`#${wrapperId} #datatables-custom`)
          .removeClass("hidden")
          .attr("data-context-id", wrapperId)
          .find("*")
          .attr("data-context-id", wrapperId);
      }
    },
  });
});
